<template>
    <div class="h100">
        <div class="error-404 shadow">
            <a href="/home.html">返回首页</a>
        </div>
        <v-footer class="footer-fix"></v-footer>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        methods: {
            
        },
        components: {
           
        }
    }
</script>

<style lang="scss">
    .h100 {
        height: 100%;
        position: relative;
    }
    .error-404 {
        width: 900px;
        position: absolute;
        top: 90px;
        bottom: 270px;
        left: 50%;
        margin-left: -450px;
        background: url('../assets/404.png') no-repeat 50% 30% #fff;
        a{
            width: 100px;
            position: absolute;
            bottom: 5%;
            left: 50%;
            margin-left: -50px;
            color: #1e6ecc;
        }
    }
    .footer-fix {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
    }
</style>
